module.exports = __webpack_public_path__ + "static/media/LawNew.1ecad58f.svg";